export default "__VITE_ASSET__3d3fc249__"